/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Desk_WeekInputs */

const en_features_desk_week = /** @type {(inputs: Features_Desk_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2–6 November`)
};

const pl_features_desk_week = /** @type {(inputs: Features_Desk_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2–6 listopada`)
};

/**
* | output |
* | --- |
* | "2–6 November" |
*
* @param {Features_Desk_WeekInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_desk_week = /** @type {((inputs?: Features_Desk_WeekInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Desk_WeekInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_desk_week(inputs)
	return en_features_desk_week(inputs)
});